<template>
	<div>
		<Breadcrumbs main="user.resource" title="user.header"/>
		<!-- Container-fluid starts-->
		<div class="container-fluid">
            <div id="addUser" v-show="process === 'add' ">
                <div class="row ml-1" v-b-hover="handleHover">
                        <h3 class="text-primary">{{ $t('createUser.create') }}</h3>
                        <span class="text-danger" style="font-size: 30px; font-weight: bold; cursor: pointer" @click="process = 'info' ">&times;</span>
                        <span v-show="isHovered" class="text-danger">{{ $t('user.cancelReturn')  }} </span>
                </div>
                <div class="card gradient-wy mt-4 p-4">
                    <h3 class="text-center text-info ">{{ $t('createUser.nameAndPassword') }}</h3>
                    <form class="theme-form">
                        <div class="form-row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="name" class="col-form-label text-primary f-w-600">{{ $t('register.name') }}</label>
                                    <input class="form-control" id="name" v-model="name" type="text" :placeholder="$t('register.namePh')">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="phone" class="col-form-label text-primary f-w-600">{{ $t('register.phone') }}</label>
                                    <input class="form-control" id="phone" v-model="phone" type="text" :placeholder="$t('register.phonePh') ">
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="email" class="col-form-label text-primary f-w-600">{{ $t('register.email') }}</label>
                                     <input class="form-control" id="email" v-model="email" type="email" :placeholder="$t('register.emailPh')">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="password" class="col-form-label text-primary f-w-600">{{ $t('register.password') }}</label>
                                    <input autocomplete="" class="form-control" id="password" v-model="password" type="password" :placeholder="$t('register.passwordPh')">
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <h4 class="f-w-600">{{ $t('register.workingPlace') }}</h4>
                            <div class="form-row">
                                <div class="col-sm-6">
                                    <label for="userCat" class="col-form-label text-primary pt-0 f-w-600">{{ $t('register.userCat') }}</label>
                                    <b-form-select :value="userCat" @input="getCompNameList" class="mb-3">
                                        <b-form-select-option value="logist">{{ $t('register.logist') }}</b-form-select-option>
                                        <b-form-select-option value="agent">{{ $t('register.agent') }}</b-form-select-option>
                                        <b-form-select-option value="trans">{{ $t('register.trans') }}</b-form-select-option>
                                        <b-form-select-option value="cert" disabled>{{ $t('register.cert') }}</b-form-select-option>
                                        <b-form-select-option value="driver" disabled>{{ $t('register.driver') }}</b-form-select-option>
                                        <b-form-select-option value="conex">{{ $t('register.conex') }}</b-form-select-option>
                                    </b-form-select>
                                </div>
                                <div class="col-sm-6 text-primary">
                                    <label for="selectedCompName" class="col-form-label text-primary pt-0 f-w-600">{{ $t("register.compId") }}</label>  
                                    <v-select 
                                        v-model="selectedCompName" 
                                        :options="compNameList"
                                        :placeholder="$t('surcharge.plsSelect')"
                                    >
                                    </v-select>
                                </div>
                            </div>
                        </div>  
                    </form>
                    <div class="d-flex flex-row justify-content-end">
                        <b-button @click="createUser_No" class="btn btn-warning" style="font-size: 20px ;" type="button">{{ $t('matchTx.no') }}</b-button>
                        <b-button @click="createUser" class="btn btn-primary ml-5" style="font-size: 20px ;" type="button">{{ $t('user.saveCreate') }}</b-button>                            
                    </div>                    
                </div>
            </div>
            <div id="editUser" v-show="process === 'edit' ">     
                <div class="row ml-1" v-b-hover="handleHoverUpdate">
                    <h3 class="text-primary">{{ $t('user.edit') }}</h3>
                    <span class="text-danger" style="font-size: 30px; font-weight: bold; cursor: pointer" @click="process = 'info' ">&times;</span>
                    <span v-show="isHoveredUpdate" class="text-danger">{{ $t('user.cancelReturn')  }} </span>
                </div>
                <div   class="card gradient-wo mt-4 p-4">
                    <form class="theme-form">
                        <div class="form-row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="name" class="col-form-label text-primary f-w-600">{{ $t('register.name') }}</label>
                                    <input class="form-control" id="name" v-model="name" type="text" :placeholder="$t('register.namePh')">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="phone" class="col-form-label text-primary f-w-600">{{ $t('register.phone') }}</label>
                                    <input class="form-control" id="phone" v-model="phone" type="text" :placeholder="$t('register.phonePh') ">
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="form-row">
                                <div class="col-md-6">
                                    <div class="form-group" v-b-popover.hover.top="$t('user.noEditEmailMsg')">
                                        <label for="email" class="col-form-label text-primary f-w-600">{{ $t('register.email') }}</label>
                                        <input class="form-control" id="email" v-model="email" type="email"  disabled>
                                    </div>
                                </div>     
                                <div class="col-sm-6">
                                    <label for="userCat" class="col-form-label text-primary f-w-600">{{ $t('register.userCat') }}</label>                           -->
                                    <b-form-select :value="userCat" :disabled="userCat == 'driver' || userCat == 'agent' || userCat == 'conex'" class="mb-3">
                                        <b-form-select-option value="logist">{{ $t('register.logist') }}</b-form-select-option>
                                        <b-form-select-option value="agent" disabled>{{ $t('register.agent') }}</b-form-select-option>
                                        <b-form-select-option value="trans">{{ $t('register.trans') }}</b-form-select-option>
                                        <b-form-select-option value="cert" disabled>{{ $t('register.cert') }}</b-form-select-option>
                                        <b-form-select-option value="driver" disabled>{{ $t('register.driver') }}</b-form-select-option>
                                        <b-form-select-option value="conex" disabled>{{ $t('register.conex') }}</b-form-select-option>
                                    </b-form-select>
                                </div>
                            </div>
                        </div>  
                    </form>
                    <div class="d-flex flex-row justify-content-end">
                        <b-button @click="editUser_No" class="btn btn-warning" style="font-size: 20px ;" type="button">{{ $t('matchTx.no') }}</b-button>
                        <b-button @click="editUser" class="btn btn-primary ml-5" style="font-size: 20px ;" type="button">{{ $t('user.saveEdit') }}</b-button>                            
                    </div>                    
                </div>
            </div>      
            <div>
                <div class="row">
                    <h2 class="mb-1 mt-4 ml-3 f-w-600">{{ $t('user.allUserList') }}</h2>  
                    <b-button v-show="process != 'add'"  pill size="sm" @click="addUserBtn" class="bg-primary mb-2 mt-3 ml-3 " href="#editUser" >
                        <span class="f-w-600 text-white" style="font-size: 18px;">{{ $t('createUser.create') }} </span>
                    </b-button>                    
                </div>                
                <div class="row">

                    <!-- <h2 class="mb-1 mt-4 ml-3 f-w-600">{{ $t('user.allUserList') }}</h2>                   -->
                    <b-modal ref="compInfo-modal"  :title="$t('company.header')" hide-footer>
                        <div>
                            <h4 class="f-w-600 text-primary mt-2 mx-2" style="font-size:16px">
                                {{ $t('refill.compNameLocal') }}
                                <span class="text-success ml-2">{{ selCompNameLocal }} </span>
                            </h4> 
                            <h4 class="f-w-600 text-primary mt-2 mx-2" style="font-size:16px">
                                {{ $t('company.busType') }}
                                <span class="text-success ml-2">{{ selBusType }} </span>
                            </h4> 
                            <h4 class="f-w-600 text-primary mt-2 mx-2" style="font-size:16px">
                                {{ $t('company.address') }}
                                <span class="text-success ml-2">{{ selCompAddress }} </span>
                            </h4> 
                        </div>
                    </b-modal>
                    <b-col lg="3" class="ml-3 mt-3">
                        <b-form-group
                        :label="$t('matchTx.filter')"
                        label-for="filter-input"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="lg"
                        class="mb-0"
                        >
                        <b-input-group size="sm">
                            <b-form-input
                            id="filter-input"
                            v-model="filter"
                            type="search"
                            :placeholder="$t('matchTx.typeToSearch')"
                            class="text-info"
                            style="font-size: 18px;"
                            ></b-form-input>
                            <b-input-group-append>
                            <b-button size="md" variant="primary" :disabled="!filter" @click="filter = ''">
                                {{ $t('matchTx.clear') }}
                            </b-button>
                            </b-input-group-append>
                        </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col lg="5" class="my-1">
                        <b-form-group
                        v-model="sortDirection"
                        :label="$t('matchTx.filterOn')"
                        :description= "$t('matchTx.uncheck')"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="lg"
                        class="mb-0"
                        v-slot="{ ariaDescribedby }"
                        >
                        <b-form-checkbox-group
                            v-model="filterOn"
                            :aria-describedby="ariaDescribedby"
                            class="mt-1 text-info"
                            plain
                        >
                            <b-form-checkbox value="name">{{ $t('user.name') }}</b-form-checkbox>                                                                
                            <b-form-checkbox value="email">{{ $t('user.email') }}</b-form-checkbox>   
                            <b-form-checkbox value="phone">{{ $t('user.phone') }}</b-form-checkbox>   
                        </b-form-checkbox-group>
                        </b-form-group>
                    </b-col>   
                </div>
                <b-table
                    sticky-header
                    head-variant="light"
                    table-variant="success"
                    show-empty
                    sort-icon-left
                    stacked="md"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :items="items"
                    :fields="fields"
                    :tbody-tr-class="rowClass"
                    :current-page="currentPage"
                    :per-page="perPage"
                    @filtered="onFiltered"
                >
                    <!-- A virtual column -->
                    <template #cell(index)="data">
                        {{ data.index + 1 }}
                    </template>
                    <template #cell(compInfo)="row" >
                        <b-button size="sm" @click="openModalCompInfo(row.item )" class="m-1">
                            {{ row.item.compId }}
                        </b-button>
                    </template>
                    <template #cell(actActive)="row" >
                        <b-button  size="sm" variant="warning" @click="actEdit(row.item)" class="m-1" href="#editUser" >
                            <span class="f-w-600" style="font-size: 14px;"> {{ $t('matchTx.edit') }}</span>
                        </b-button>                        
                        <b-button v-show="row.item.active" size="sm" variant="danger" @click="actSuspend(row.item)" class="m-1">
                            <span class="f-w-600" style="font-size: 14px;"> {{ $t('user.suspend') }}</span>
                        </b-button>
                        <b-button  v-show="!row.item.active" size="sm" variant="success" @click="actAble(row.item)" class="m-1">
                            <span class="f-w-600" style="font-size: 14px;"> {{ $t('user.able') }}</span>
                        </b-button>

                    </template>
                </b-table>
                <b-row>
                    <div class="row col-sm-8 ">
                        <b-col class="my-1 ml-3">
                            <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="fill"
                            class="my-0"
                            ></b-pagination>
                        </b-col>   
                        <b-col sm="3" md="6" class="my-1">
                            <b-form-group
                            :label= "$t('require.perPage')"
                            label-for="per-page-select"
                            label-cols-sm="6"
                            label-cols-md="4"
                            label-cols-lg="3"
                            label-align-sm="right"
                            label-size="sm"
                            class="mb-0"
                            >
                            <b-form-select
                                id="per-page-select"
                                v-model="perPage"
                                :options="pageOptions"
                            ></b-form-select>
                            </b-form-group>
                        </b-col>
                    </div>
                </b-row>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
<script>
// import { createUserWithEmailAndPassword } from 'firebase/auth'
import { createUserWithEmailAndPassword , userListAll, getData,authUser , compNameList, compIdByCompName ,saveWithId , mergeObj} from "../../firebase"
export default {
    name: 'user',
	data(){
		return{
            process : "info",
            isHovered: false,
            isHoveredUpdate: false,
            selCompNameLocal : '',
            selBusType : '',
            selCompAddress : '',
            items: [],
            fields: [
                { key: 'index', label: this.$t('seal.item'), sortable: true, }, 
                { key: 'userId', label: this.$t('user.userId'), sortable: true }, 
                { key: 'name', label: this.$t('user.name'), sortable: true },  
                { key: 'userCat', label: this.$t('user.userCat'), sortable: true,
                    formatter: value => {
                        return this.$t(`user.${value}`)
                }},                                     
                { key: 'email', label: this.$t('user.email'), sortable: true },  
                { key: 'phone', label: this.$t('user.phone'), sortable: true }, 
                { key: 'compInfo', label: this.$t('user.compId'),  variant: 'info' },             
                // { key: 'compId', label: this.$t('user.compId'), sortable: true },  
                { key: 'active', label: this.$t('user.active'), variant: 'primary',
                    formatter: value => {
                        return this.$t(`user.${value}`)
                }},
                { key: 'actActive', label: this.$t('user.actActive'), variant: 'danger'},
                { key: 'timestamp', label: this.$t('shipApproval.date'), sortable: true, variant: 'secondary',
                    formatter: value => {
                    return this.$moment(value).format("DD-MM-YY @ HH:mm")
                }},
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
            sortBy: 'timestamp',            
            sortDesc: true,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            compNameList : [],
            userId : '',
            name : '',
            phone : '',
            userCat : '',
            selectedCompName : '',
            email: '',
            password: '',
            compId:'',
		}
	},
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },
    },
	mounted(){
        userListAll((res)=>{
            this.items = res
            this.totalRows = res.length
        })
	},
	methods:{
        onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
        rowClass(item, type) {
            if (!item || type !== 'row') return
            if (item.active === false) return 'table-danger'
        },
        async refresh(){
            await userListAll( (res)=>{
            this.items = res
            this.totalRows = res.length
            })
        },
        refreshInput(){
            this.userId= '',
            this.name = '',
            this.phone = '',
            this.email = '',
            this.password = '',            
            this.userCat = '',
            this.selectedCompName = '',
            this.compId = ''
        },        
        openModalCompInfo(item) {
            getData("Company" , "compId" , item.compId, (res)=>{
                this.selCompNameLocal = res[0].compNameLocal
                this.selBusType = res[0].busType
                this.selCompAddress = res[0].compAddress
            })
            this.$refs['compInfo-modal'].show()
        },
        addUserBtn(){
            this.refreshInput()
            this.process = 'add'
        },
        actSuspend(item) {
            this.$bvModal.msgBoxConfirm(this.$t('user.confirmSuspendMsg'), {
            title: this.$t('matchTx.plsConfirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('matchTx.yes'),
            cancelTitle: this.$t('matchTx.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async(value) => {
                if (value) {
                    await mergeObj('Users' , item.userId , {
                        active : false,
                        timestamp:  Date.parse(new Date())
                    })
                     this.refresh()                    
                    this.$toasted.show( this.$t('user.suspended'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
                } else {
                return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Delete: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        },    

        actAble(item) {
            this.$bvModal.msgBoxConfirm(this.$t('user.confirmAbleMsg'), {
            title: this.$t('matchTx.plsConfirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('matchTx.yes'),
            cancelTitle: this.$t('matchTx.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async(value) => {
                if (value) {
                    await mergeObj('Users' , item.userId , {
                        active : true,
                        timestamp:  Date.parse(new Date())
                    })
                     this.refresh()                    
                    this.$toasted.show( this.$t('user.abled'), {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 5000});  
                } else {
                return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Delete: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        },    
        actEdit(item){
            this.userId = item.userId
            this.name = item.name,
            this.phone = item.phone,
            this.email = item.email,         
            this.userCat = item.userCat,
            this.process = 'edit'
        
        },
        async getCompNameList(value){
            this.userCat = value 
            let opt = value === 'agent' ? '==' : '!='
            await compNameList(  opt ,(res)=>{
                this.compNameList = res
            })            
        },
        createUser_No(){
            this.refreshInput()
            this.process = 'info'
        },

        createUser() {
            let msg = 'completed'
            let pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
            if (this.name === ''){
                msg = "Please enter user name."
            } else if (this.phone ===''){
                msg = "Please enter phone no."
            } else if (this.email ===''){
                msg = "Please enter your email address."
            } else if (!pattern.test(this.email)){
                msg = "Please verify your email format."
            } else if (this.password ===''){
                msg = "Please enter your password."
            } else if (this.password.length < 8){
                msg = "Password must be 8 digits up."
            } else if (this.userCat ===''){
                msg = "Please select user's role or category."
            } else if (this.selectedCompName ===''){
                msg = "Please select user's company."
            }  
            if (msg === 'completed'){
                createUserWithEmailAndPassword(authUser, this.email, this.password)
                .then( async(userCredential) => {
                    if (userCredential) {
                        await compIdByCompName(this.selectedCompName, async(compId)=>{
                            let userId = `${Math.floor(Math.random() * (9000000 - 1000000 + 1) + 1000000)}`
                            let payload = {
                                uid: userCredential.user.uid,
                                userId : userId,
                                name: this.name,
                                phone: this.phone,
                                userCat: this.userCat,
                                compId: compId,
                                email: this.email,
                                active: true,
                                timestamp: Date.parse(new Date())
                            }
                            await saveWithId('Users', userId, payload).then(()=>{
                                this.$toasted.show('Success register to email:' + this.email, {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 5000});    
                                this.refreshInput()                                
                                this.refresh()
                            })
                        })
                    }
                })
                .catch((error) => {
                    this.$toasted.show('Error...' + error.message, {theme: 'bubble',   position: 'bottom-center',   type: 'error', duration: 5000});
                });                                              
            }else{
                this.$toasted.show(msg, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
        editUser_No(){
            this.refreshInput()
            this.process = 'info'
        },

        async editUser() {
            let msg = 'completed'
            if (this.name === ''){
                msg = "Please enter user name."
            } else if (this.phone ===''){
                msg = "Please enter phone no."
            } else if (this.userCat ===''){
                msg = "Please select user's role or category."
            }  
            if (msg === 'completed'){
                let payload = {
                    name: this.name,
                    phone: this.phone,
                    userCat: this.userCat,
                    active: true,
                    timestamp: Date.parse(new Date())
                }
                await mergeObj('Users', this.userId, payload).then(()=>{
                    this.$toasted.show(this.$t('user.successEditUser') + this.name, {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 5000});    
                    this.refreshInput()
                    this.refresh()
                })                   
            }else{
                this.$toasted.show(msg, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
        handleHover(hovered) {
            this.isHovered = hovered
        },
        handleHoverUpdate(hovered) {
            this.isHoveredUpdate = hovered
        },
    }
}
</script>
<style scoped>
 .gradient-wo {
   background: linear-gradient(135deg, white, rgb(255, 187, 0));
 }
 .gradient-wy {
   background: linear-gradient(135deg, white, yellow);
 }
</style>

